import React from "react";

type Status =
  | "available"
  | "busy"
  | "offline"
  | "claimed"
  | "installing"
  | "ready"
  | "passed"
  | "failed"
  | "running"
  | "queued"
  | "cancelled";

const statusStyles: Record<
  string,
  { background: string; color: string }
> = {
  available: {
    background: "var(--color-status-available-bg)",
    color: "var(--color-status-available-text)",
  },
  passed: {
    background: "var(--color-status-available-bg)",
    color: "var(--color-status-available-text)",
  },
  busy: {
    background: "var(--color-status-busy-bg)",
    color: "var(--color-status-busy-text)",
  },
  running: {
    background: "var(--color-status-busy-bg)",
    color: "var(--color-status-busy-text)",
  },
  queued: {
    background: "var(--color-status-busy-bg)",
    color: "var(--color-status-busy-text)",
  },
  offline: {
    background: "var(--color-status-offline-bg)",
    color: "var(--color-status-offline-text)",
  },
  claimed: {
    background: "var(--color-status-claimed-bg)",
    color: "var(--color-status-claimed-text)",
  },
  installing: {
    background: "var(--color-status-installing-bg)",
    color: "var(--color-status-installing-text)",
  },
  ready: {
    background: "var(--color-status-ready-bg)",
    color: "var(--color-status-ready-text)",
  },
  failed: {
    background: "var(--color-status-offline-bg)",
    color: "var(--color-status-offline-text)",
  },
  cancelled: {
    background: "var(--color-foreground)",
    color: "var(--color-neutral)",
  },
};

interface StatusBadgeProps {
  status: string;
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  const normalized = status.toLowerCase();
  const style = statusStyles[normalized] ?? {
    background: "var(--color-foreground)",
    color: "var(--color-neutral)",
  };

  return (
    <span
      style={{
        display: "inline-block",
        fontSize: "var(--font-size-xs)",
        fontWeight: 600,
        padding: "2px var(--space-sm)",
        borderRadius: "var(--radius-pill)",
        textTransform: "uppercase",
        letterSpacing: "0.3px",
        whiteSpace: "nowrap",
        background: style.background,
        color: style.color,
      }}
    >
      {status}
    </span>
  );
}
